import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {DustDbService, GasDbService} from '@/views/shared/services';
import {Component} from 'vue-property-decorator';

@Component
export default class ImportDustDbDialogComponent extends VueWrapper {
    public readonly name: string = 'import-dust-db-dialog';

    public readonly dustDbSrv: DustDbService = new DustDbService();

    public file: File | null = null;

    public filesSelected(event: FileList) {
        if (event.length > 0) {
            this.file = event.item(0);
        }
    }

    public save() {
        if (this.file) {
            this.LoaderSrv.showFullScreenLoader('$t.Common.ImportingData.Uploading');
            this.dustDbSrv
                .uploadFile(this.file)
                .then(() => {
                    this.file = null;
                    this.close();
                    this.AlertSrv.show('success', '$t.Common.ImportingData.Started');
                })
                .catch(() => {
                    this.AlertSrv.show('error', '$t.Common.ImportingData.ImportError');
                })
                .finally(() => {
                    this.LoaderSrv.hideFullScreenLoader();
                });
        }
    }

    public open() {
        this.CoreSrv.OpenModal(this.name);
    }

    public close() {
        this.file = null;
        this.CoreSrv.CloseModal(this.name);
    }
}
